import generateActions from 'utils/actions';
import { getCurrentUser } from '../auth/selectors';

export const DELETE_MESSAGE = generateActions('mailbox/DELETE_MESSAGE');
export const LOAD_CATEGORIES = generateActions('mailbox/LOAD_CATEGORIES');
export const LOAD_THREAD = generateActions('mailbox/LOAD_THREAD');
export const LOAD_THREADS = generateActions('mailbox/LOAD_THREADS');
export const POST_THREAD = generateActions('mailbox/POST_THREAD');
export const POST_REPLY = generateActions('mailbox/POST_REPLY');

export function loadCategories() {
  return {
    types: LOAD_CATEGORIES,
    promise: {
      url: '/forum/categories',
    },
  };
}

export function loadThread(id) {
  return {
    types: LOAD_THREAD,
    promise: {
      url: `/forum/threads/${id}`,
    },
  };
}

export function loadThreads(category) {
  return {
    types: LOAD_THREADS,
    promise: {
      url: '/forum/threads',
      data: { category },
    },
  };
}

export function postThread(thread) {
  return (dispatch, getState) => {
    const author = getCurrentUser(getState());

    return dispatch({
      types: POST_THREAD,
      promise: {
        url: '/forum/threads',
        method: 'POST',
        data: thread,
      },
      data: { thread, author }
    });
  }
}

export function postReply(thread, content) {
  return (dispatch, getState) => {
    const author = getCurrentUser(getState());

    return dispatch({
      types: POST_REPLY,
      promise: {
        url: `/forum/threads/${thread.id}`,
        method: 'POST',
        data: { content },
      },
      data: { thread, author, content }
    });
  }
}

export function deleteMessage(thread) {
  return {
    types: DELETE_MESSAGE,
    promise: {
      url: `/forum/threads/${thread.id}/message/${thread.messageId}`,
      method: 'DELETE'
    },
    data: { thread },
  };
}
